export const requestSetting = new class setting {
	getNonceStr() {
		return uni.$uv.guid().toLowerCase();
	}

	getRequestSign(secret = '', timestamp = '', nonceStr = '', data = {}) {
		let sign = secret;
		if(data && Object.keys(data).length > 0) {
			sign += JSON.stringify(data);
		}
		sign += secret + timestamp + nonceStr;
		return uni.$sk.func.md5(sign);
	}
} 
